<template>
  <div class="flex items-center gap-0">
    <div
      v-for="(step, i) in steps"
      :key="step.id"
      class="flex flex-1 items-center"
    >
      <div class="flex items-center gap-2.5">
        <div
          class="flex h-7 w-7 items-center justify-center rounded-full text-xs font-semibold transition-all duration-300"
          :class="
            currentStep > i
              ? 'bg-green-600 text-white'
              : currentStep === i
                ? 'bg-navy-800 text-white'
                : 'bg-neutral-200 text-neutral-400'
          "
        >
          <i v-if="currentStep > i" class="pi pi-check text-xs" />
          <span v-else>{{ i + 1 }}</span>
        </div>
        <span
          class="text-[13px]"
          :class="
            currentStep === i
              ? 'text-navy-800 font-semibold'
              : 'text-neutral-400'
          "
        >
          {{ step.label }}
        </span>
      </div>
      <div
        v-if="i < steps.length - 1"
        class="mx-4 h-px flex-1 transition-colors duration-300"
        :class="currentStep > i ? 'bg-green-600' : 'bg-neutral-200'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  currentStep: number
}>()

const steps = [
  { id: "file-number", label: "File Number" },
  { id: "parties", label: "Parties" },
  { id: "documents", label: "Documents" },
  { id: "review", label: "Review" },
]
</script>
